export default __webpack_public_path__ + "static/media/ventilador.21f58c4c.jpg";